import { ValidationResult } from "src/app/ui/models/domains/validator/validation-result";
import "moment/locale/pt-br";
import moment from 'moment';
import { SocialNumber } from "src/app/ui/models/domains/pbm/social-number.model";
import { Dependent } from "src/app/ui/models/domains/pbm/Beneficiary/dependent";
import { UntypedFormGroup } from "@angular/forms";
import { Beneficiary } from "src/app/ui/models/domains/pbm/Beneficiary/beneficiary";

export class DependentValidator {
  private validationResult = new ValidationResult();

  constructor(private beneficiary: Beneficiary) {}

  getValidationResult(): ValidationResult {
    return this.validationResult;
  }

  validate(dependentForm: UntypedFormGroup, behavior: IDependentBehaviorValidator): ValidationResult {
    const email = dependentForm.get("email").value;
    const needValidateEmail = dependentForm.get("needValidateEmail").value;
    const enableDelivery = dependentForm.get("enableDelivery").value;

    const emailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const gender = dependentForm.get("gender").value;
    const maritalStatus = dependentForm.get("maritalStatus").value;

    if (!dependentForm.get("name").value) {
      this.validationResult.addErrorMessage("É necessário inserir um nome");
    } else if (!dependentForm.get("socialNumber").value) {
      this.validationResult.addErrorMessage("É necessário inserir um CPF");
    } else if (!SocialNumber.isValid(dependentForm.get("socialNumber").value)) {
      this.validationResult.addErrorMessage("CPF inválido");
    } else if (!this.validateSocialNumber(dependentForm, behavior)) {
      this.validationResult.addErrorMessage("Dependente já cadastrado para esse beneficiário");
    } else if (gender === null) {
      this.validationResult.addErrorMessage("É necessário selecionar um Sexo");
    } else if (maritalStatus === null) {
      this.validationResult.addErrorMessage("É necessário selecionar um Estado Civil");
    } else if (!!dependentForm.get("birthDate").value && !moment(dependentForm.get("birthDate").value, "DDMMYYYY").isValid()) {
      this.validationResult.addErrorMessage("Data de nascimento inválida");
    } else if (dependentForm.get("email").value && !emailRegex.test(dependentForm.get("email").value.toLowerCase())) {
      this.validationResult.addErrorMessage("E-mail Invalido!");
    } else if (dependentForm.get("isNewAddress").value == true && !dependentForm.get("region").value) {
      this.validationResult.addErrorMessage("É necessário inserir um Estado");
    } else if (dependentForm.get("isNewAddress").value == true && !dependentForm.get("city").value) {
      this.validationResult.addErrorMessage("É necessário inserir uma Cidade");
    } else if (dependentForm.get("isNewAddress").value == true && !dependentForm.get("district").value) {
      this.validationResult.addErrorMessage("É necessário inserir um Bairro");
    } else if (needValidateEmail && !email) {
      this.validationResult.addErrorMessage("É necessário inserir um E-mail");
    } else if (email && !emailRegex.test(email.toLowerCase())) {
      this.validationResult.addErrorMessage("E-mail inválido");
    }
    return this.validationResult;
  }

  private validateSocialNumber(dependentForm: UntypedFormGroup, behavior: IDependentBehaviorValidator): boolean {
    return behavior.validateSocialNumber(dependentForm, this.beneficiary);
  }
}

export interface IDependentBehaviorValidator {
  validateSocialNumber(dependentForm: UntypedFormGroup, beneficiary: Beneficiary): boolean;
}

export abstract class DependentBehaviorValidator {
  validateSocialNumber(dependentForm: UntypedFormGroup, beneficiary: Beneficiary): boolean {
    const beneficiarySocialNumber = beneficiary.getSocialNumber();
    const dependentSocialNumberList = beneficiary.getDependets().map((dependent) => {
      return dependent.getSocialNumber();
    });
    const dependentSocialNumber = dependentForm.get("socialNumber").value.replace(/[^\d]+/g, "");
    return (
      beneficiarySocialNumber !== dependentSocialNumber && !dependentSocialNumberList.some((socialNumberItem) => socialNumberItem === dependentSocialNumber)
    );
  }
}

export class AddDependentBehaviorValidator extends DependentBehaviorValidator implements IDependentBehaviorValidator {
  validateSocialNumber(dependentForm: UntypedFormGroup, beneficiary: Beneficiary): boolean {
    return super.validateSocialNumber(dependentForm, beneficiary);
  }
}

export class EditDependentBehaviorValidator extends DependentBehaviorValidator implements IDependentBehaviorValidator {
  constructor(private dependent: Dependent) {
    super();
  }
  validateSocialNumber(dependentForm: UntypedFormGroup, beneficiary: Beneficiary): boolean {
    const dependentSocialNumber = dependentForm.get("socialNumber").value.replace(/[^\d]+/g, "");
    if (dependentSocialNumber !== this.dependent.getSocialNumber()) {
      return super.validateSocialNumber(dependentForm, beneficiary);
    }
    return true;
  }
}
